import React from 'react';
import cn from 'classnames';

const Instruction = ({ icon, instruction, marginOver, smallPadding }) => {
  const Icon = iconsList[icon];
  return (
    <div
      className={cn(
        'py-8 px-6 bg-neutral-100 flex justify-center',
        marginOver ? 'pt-6 pb-20' : '',
        smallPadding ? 'pt-4 pb-4' : ''
      )}
    >
      {icon && <Icon />}
      <p className="text-blueberry text-lg">{instruction}</p>
    </div>
  );
};

Instruction.defaultProps = {
  icon: false,
  instruction: 'Please label any people, places, organizations in the following text',
  marginOver: false,
  smallPadding: false
};

const AskIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-6 w-6 mr-4 shrink-0 text-blueberry fill-current"
    style={{ marginTop: 4 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0429 14.75V14.75C18.8565 14.8662 18.7296 15.0573 18.6947 15.2741V15.2741C18.3344 17.5222 16.2198 19.0525 13.9718 18.6922C13.4326 18.6058 12.9161 18.4131 12.452 18.1254V18.1254C12.1762 17.9521 11.8255 17.9521 11.5497 18.1254V18.1254C10.4551 18.8056 9.1047 18.9326 7.90241 18.4686V18.4686C7.79414 18.4225 7.67021 18.4317 7.57001 18.4935V18.4935C6.88411 18.95 5.958 18.764 5.50149 18.0781C5.16756 17.5764 5.16832 16.923 5.50343 16.422V16.422C5.5655 16.3218 5.57504 16.1977 5.529 16.0892V16.0892C5.42832 15.8281 5.35454 15.5575 5.3088 15.2814V15.2814C5.27429 15.0626 5.14721 14.8693 4.96005 14.7508V14.7508C3.02336 13.5587 2.41982 11.0222 3.612 9.08553C3.94942 8.5374 4.41063 8.076 4.95863 7.73836V7.73836C5.14503 7.62222 5.27203 7.43107 5.30685 7.21422V7.21422C5.66724 4.9661 7.78186 3.4358 10.03 3.79617C10.5691 3.88259 11.0856 4.07523 11.5497 4.36291V4.36291C11.8254 4.53627 12.1762 4.53627 12.4519 4.36291V4.36291C14.387 3.16324 16.9282 3.75938 18.1279 5.69444C18.4156 6.1585 18.6082 6.67509 18.6946 7.21422V7.21422C18.7295 7.43105 18.8565 7.62218 19.0429 7.73836V7.73836C20.9791 8.93119 21.5817 11.4678 20.3889 13.404C20.0515 13.9517 19.5905 14.4127 19.0429 14.75L19.0429 14.75ZM11.9986 16.4941V16.4941C12.6199 16.4941 13.1236 15.9904 13.1236 15.3691C13.1236 14.7478 12.6199 14.2441 11.9986 14.2441C11.3772 14.2441 10.8736 14.7478 10.8736 15.3691V15.3691C10.8736 15.9904 11.3772 16.4941 11.9986 16.4941C11.9986 16.4941 11.9986 16.4941 11.9986 16.4941V16.4941ZM12.748 5.99411H11.2558V5.99411C11.0467 5.99168 10.8751 6.15928 10.8727 6.36844C10.8726 6.37524 10.8728 6.38204 10.873 6.38883L11.216 12.7638V12.7638C11.2291 12.9651 11.3972 13.1211 11.5989 13.1191H12.405V13.1191C12.6067 13.1211 12.7749 12.9652 12.7879 12.7638L13.131 6.38883V6.38883C13.1398 6.17984 12.9775 6.00327 12.7685 5.99446C12.7617 5.99417 12.7549 5.99407 12.748 5.99415L12.748 5.99411ZM4.12577 18.7441V18.7441C4.74709 18.7441 5.25077 19.2478 5.25077 19.8691C5.25077 20.4904 4.74709 20.9941 4.12577 20.9941C3.50445 20.9941 3.00077 20.4904 3.00077 19.8691V19.8691C3.00077 19.2478 3.50443 18.7442 4.12574 18.7441L4.12577 18.7441Z"
      fill="#943CFF"
    />
  </svg>
);

const LabelIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-6 w-6 mr-4 shrink-0 text-blueberry fill-current"
    style={{ marginTop: 4 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25775 17.2578H14.2578C14.672 17.2578 15.0078 17.5935 15.0078 18.0078C15.0078 18.422 14.672 18.7578 14.2578 18.7578H5.25775C4.84354 18.7578 4.50775 18.422 4.50775 18.0078C4.50775 17.5935 4.84354 17.2578 5.25775 17.2578H5.25775ZM18.7578 15.7578H5.25775H5.25775C4.84354 15.7578 4.50775 15.422 4.50775 15.0078C4.50775 14.5935 4.84354 14.2578 5.25775 14.2578H18.7578C19.172 14.2578 19.5078 14.5935 19.5078 15.0078C19.5078 15.422 19.172 15.7578 18.7578 15.7578ZM5.25775 11.2578H18.0078C18.422 11.2578 18.7578 11.5935 18.7578 12.0078C18.7578 12.422 18.422 12.7578 18.0078 12.7578H5.25775C4.84354 12.7578 4.50775 12.422 4.50775 12.0078C4.50775 11.5935 4.84354 11.2578 5.25775 11.2578H5.25775ZM5.25775 8.25775H15.7578C16.172 8.25775 16.5078 8.59354 16.5078 9.00775C16.5078 9.42197 16.172 9.75775 15.7578 9.75775H5.25775C4.84354 9.75775 4.50775 9.42197 4.50775 9.00775C4.50775 8.59354 4.84354 8.25775 5.25775 8.25775H5.25775ZM18.7578 6.75775H5.25775H5.25775C4.84354 6.75775 4.50775 6.42197 4.50775 6.00775C4.50775 5.59354 4.84354 5.25775 5.25775 5.25775H18.7578C19.172 5.25775 19.5078 5.59354 19.5078 6.00775C19.5078 6.42197 19.172 6.75775 18.7578 6.75775Z"
      fill="#7F2CF3"
    />
  </svg>
);

const iconsList = {
  ask: AskIcon,
  label: LabelIcon
};

export default Instruction;
